<script setup lang="ts">
import { useForwardProps } from 'reka-ui'

import { Flex, type FlexProps } from '@/components'

import * as styles from './Footer.css'

export interface DialogFooterProps extends FlexProps {}

const props = defineProps<DialogFooterProps>()
const forward = useForwardProps(props)
</script>

<template>
  <Flex
    v-bind="forward"
    as-child
    background-color="tertiary50"
    :class="styles.container"
    justify-content="end"
    margin-block-start="20"
    margin-inline="-90"
    :padding-block-start="60"
    :padding-block-end="100"
    :padding-inline="80"
    position="sticky"
  >
    <footer>
      <Flex justify-content="space-between" width="full">
        <slot />
      </Flex>
    </footer>
  </Flex>
</template>
